var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "page_Container" } }, [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _c("div", { staticClass: "couponsrules" }, [
              _c("div", { staticClass: "title" }, [_vm._v("优惠券规则")]),
              _vm._v(" "),
              _c("div", { staticClass: "contain" }, [
                _c("p", [_vm._v("1，一次下单只能使用一张优惠券")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "2，支持优惠券的商品，若满减条件相同（如满199元减20元）且实际付款金额达到满减门槛，可共用一张优惠券"
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("3，运费，税金等不计入满减门槛")])
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }